import {
  sanitizeString,
  toCount,
  toSpend,
} from 'utilities/string';

export const lineCounts = [
  {
    label: '5',
    value: 5,
  },
  {
    label: '10',
    value: 10,
  },
];

export const visualizationTypes = [
  {
    icon: 'column',
    label: 'Column',
    value: 'column',
  },
  {
    icon: 'line',
    label: 'Line (Single Metric)',
    value: 'single_line',
  },
  {
    icon: 'line',
    label: 'Line (Multi Metric)',
    value: 'multi_line',
  },
];

export const showTotalFormats = ['number', 'spend'];

export function totalFormatter(format, value) {
  switch (format) {
    case 'number':
      return toCount(value);
    case 'spend':
      return toSpend(value);
    default:
      return value;
  }
}

export function setTableStyles(
  metrics,
  segments,
  dateCount,
  lastDate,
  hasColorPreview,
  showTotals,
) {
  const sheet = new CSSStyleSheet();
  const tableBorderStyle = 'border-right: 1px solid var(--grey-200);';
  const tableShadedStyle = 'background-color: #F9F9F9;';
  const styles = [];
  const numSegments = segments.length;
  // NOTE: Adding 1 when the chart color preview column is included
  const numSegmentColumns = hasColorPreview ? numSegments + 1 : numSegments;

  if (numSegments > 0) {
    const lastSegment = segments[numSegments - 1];
    const sanitizedLastSegment = sanitizeString(lastSegment.value);

    styles.push(`
      tr:first-child th:first-child { ${tableBorderStyle} }
      tr:last-child th:nth-child(${numSegmentColumns}) { ${tableBorderStyle} }
      tr .tableColumn-${sanitizedLastSegment} { ${tableBorderStyle} }
    `);
  }

  let latestHeaderIndex = numSegments > 0 || hasColorPreview ? 1 : 0;
  let latestSubheaderIndex = numSegmentColumns;
  const metricStyles = metrics.map(({ format, value }) => {
    const hasTotalColumn = showTotalFormats.includes(format) && showTotals;
    const backgroundStyle = hasTotalColumn ? tableShadedStyle : '';

    const headerIndex = latestHeaderIndex + (hasTotalColumn ? 2 : 1);
    const subheaderIndex = latestSubheaderIndex + dateCount + (hasTotalColumn ? 1 : 0);
    const headerStyle = `
      tr:first-child th:nth-child(${headerIndex}) { ${tableBorderStyle} ${backgroundStyle} }
      tr:last-child th:nth-child(${subheaderIndex}) { ${tableBorderStyle} ${backgroundStyle} }
    `;
    latestHeaderIndex = headerIndex;
    latestSubheaderIndex = subheaderIndex;

    const lastMetricColumnValue = hasTotalColumn ? 'total' : lastDate;
    const sanitizedMetric = sanitizeString(`${value}::${lastMetricColumnValue}`);
    const rowStyle = `tr .tableColumn-${sanitizedMetric} { ${tableBorderStyle} ${backgroundStyle} }`;

    return `${headerStyle}\n${rowStyle}`;
  });
  styles.push(...metricStyles);

  sheet.replaceSync(styles.join('\n'));

  document.adoptedStyleSheets = [sheet];
}
